module.exports = __webpack_public_path__ + "img/home_51.52d2deab.png";